/**
 * @generated SignedSource<<0bb3e37119cc39f9efdc8b52c48b30bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActiveEarnDiscount_charge$data = {
  readonly discount: number | null | undefined;
  readonly " $fragmentType": "PaymentLinkActiveEarnDiscount_charge";
};
export type PaymentLinkActiveEarnDiscount_charge$key = {
  readonly " $data"?: PaymentLinkActiveEarnDiscount_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveEarnDiscount_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActiveEarnDiscount_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discount",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "daf0bfc363f155342a56f9c23a401192";

export default node;
